import { createContext, useContext, useLayoutEffect, useRef } from 'react';

export interface ModalFrameContext {
  portalContainer: HTMLElement | null;
  busy: boolean;
  registerPopover: (close: () => void) => () => void;
  registerClose: (close: () => void, disabled: boolean, size?: 'compact' | 'form' | 'document', label?: string) => () => void;
}

export const ModalFrame = createContext<ModalFrameContext | null>(null);
export const useModalFrame = () => useContext(ModalFrame);

export function usePopoverContainer(): HTMLElement | null {
  return useModalFrame()?.portalContainer ?? (typeof document === 'undefined' ? null : document.body);
}

export function useModalPopover(open: boolean, close: () => void): void {
  const frame = useModalFrame();
  const closeRef = useRef(close);
  closeRef.current = close;
  useLayoutEffect(() => {
    if (open && frame) return frame.registerPopover(() => closeRef.current());
  }, [open, frame]);
}
